import React, { useState } from "react";
export default function AuditLogConfig() {
  const [selected, setSelected] = useState({});
  const groupedOptionss = {
    auditLog: {
      label: "Audit Log",
      sections: {
        Security: [
          "Login & Authentication",
          "Password Management",
          "User Management",
          "System Backup",
        ],
        Filters: [
          "Create / Edit Filter",
          "Status Updates",
          "Retire / Replace Filters",
          "Bulk Operations & Downloads",
        ],

        AHU: ["Create AHU", "Edit AHU", "AHU Bulk Upload"],
        Blocks: ["Create Block", "Edit Block", "Delete Block", "Assign Areas"],
        Approvals: ["Send Approval", "Update Approval"],
        Equipments: ["Add Equipment", "Edit Equipment"],
        RFID: ["RFID Update"],
        Checklist: ["Checklist Create", "Checklist Update"],
        Reports: ["PDF Download"],
      },
    },

    notifications: {
      label: "Notifications",
      sections: {
        All: ["All Notifications"],
        Warning: ["Password Expiry Notification", "User Account Locked"],
        Alerts: [
          "Forgot Password Request",
          "User Deleted",
          "All Deviations/Alarms",
          "Any Edit Approved/Rejected by Approver",
          "Request Raised by Supervisor",
        ],
      },
    },

    deviations: {
      label: "Deviations",
      sections: {
        "All Deviations": [
          "Filter Skipped Stage",
          "Dry Out Scanned Before Duration Completed",
          "Pressure Out of Range at Wash-In",
        ],
      },
    },
  };

  const toggle = (name) => {
    setSelected((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  const [selectedSections, setSelectedSections] = useState({});

  const groupedOptions = {
    auditLog: {
      label: "Audit Log",
      sections: [
        "Security",
        "Filters",
        "AHU",
        "Blocks",
        "Approvals",
        "Equipments",
        "RFID",
        "Checklist",
        "Reports",
      ],
    },

    notifications: {
      label: "Notifications",
      sections: ["All", "Warnings", "Alerts"],
    },

    deviations: {
      label: "Deviations",
      sections: ["All Deviations"],
    },
  };

  const toggleSection = (name) => {
    setSelectedSections((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  return (
    <div className="page-wrapper">
      {" "}
      <div className="content">
        <div style={{ padding: 16 }}>
          {Object.entries(groupedOptionss).map(([key, group]) => (
            <div key={key} className="mb-4">
              {/* main section title stacked vertically */}
              <h4 className="mb-3">{group.label}</h4>

              <div className="row">
                {Object.entries(group.sections).map(([sectionName, items]) => (
                  <div key={sectionName} className="col-md-3 col-sm-6">
                    <div className="card mb-3">
                      <div className="card-body">
                        <h6 className="card-title">{sectionName}</h6>

                        {items.map((item) => (
                          <div className="form-check" key={item}>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={!!selected[item]}
                              onChange={() => toggle(item)}
                              id={item}
                            />
                            <label className="form-check-label" htmlFor={item}>
                              {item}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}

          <pre>{JSON.stringify(selected, null, 2)}</pre>

          {Object.entries(groupedOptions).map(([key, group]) => (
            <div key={key} className="mb-4">
              {/* main titles vertically */}
              <h4 className="mb-3">{group.label}</h4>

              <div className="row">
                {group.sections.map((sectionName) => (
                  <div key={sectionName} className="col-md-3 col-sm-6">
                    <div className="card mb-3">
                      <div className="card-body">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={!!selectedSections[sectionName]}
                            onChange={() => toggleSection(sectionName)}
                            id={sectionName}
                          />
                          <label
                            className="form-check-label fw-bold"
                            htmlFor={sectionName}
                          >
                            {sectionName}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
